import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AdminAuthService } from '../../service/admin-auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {

  constructor(
    private authService: AdminAuthService,
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.oidcSecurityService.checkAuth().pipe(
      take(1),
      switchMap(({ isAuthenticated }) => {
        if (isAuthenticated && localStorage.getItem('admin_logged_in') === 'true') {
          const userName = localStorage.getItem('admin_user_name');
          const userEmail = localStorage.getItem('admin_user_email');
          const tenantId = localStorage.getItem('admin_tenant_id');
          this.authService.login(userName!, userEmail!, tenantId!);
          return of(true);
        } else {
          this.authService.logout();
          return of(this.router.createUrlTree(['/admin/home']));
        }
      })
    );
  }

}
